import Model from 'flarum/common/Model';
/**
 * A wiki article. `content` is the raw markdown source (used to pre-fill the
 * editor); `contentHtml` is the rendered output. The `can*` booleans are
 * server-computed per-actor gates the UI uses to decide which controls to show.
 */
export default class WikiArticle extends Model {
  title = (() => Model.attribute('title'))();
  slug = (() => Model.attribute('slug'))();
  position = (() => Model.attribute('position'))();
  isDraft = (() => Model.attribute('isDraft'))();
  faq = (() => Model.attribute('faq'))();
  content = (() => Model.attribute('content'))();
  contentHtml = (() => Model.attribute('contentHtml'))();
  excerpt = (() => Model.attribute('excerpt'))();
  revisionCount = (() => Model.attribute('revisionCount'))();
  canUpdate = (() => Model.attribute('canUpdate'))();
  canDelete = (() => Model.attribute('canDelete'))();
  isDeleted = (() => Model.attribute('isDeleted'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  updatedAt = (() => Model.attribute('updatedAt', Model.transformDate))();
  lastEditedAt = (() => Model.attribute('lastEditedAt', Model.transformDate))();
  deletedAt = (() => Model.attribute('deletedAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  lastEditedBy = (() => Model.hasOne('lastEditedBy'))();
  category = (() => Model.hasOne('category'))();
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiArticle', WikiArticle);